import { render, staticRenderFns } from "./KimlikUyusmazligiDialog.vue?vue&type=template&id=000bbab1&scoped=true"
import script from "./KimlikUyusmazligiDialog.vue?vue&type=script&lang=ts"
export * from "./KimlikUyusmazligiDialog.vue?vue&type=script&lang=ts"
import style0 from "./KimlikUyusmazligiDialog.vue?vue&type=style&index=0&id=000bbab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bbab1",
  null
  
)

export default component.exports